<template>
  <div id="app">
    <the-header></the-header>
    <section class="section is-fullheight">
      <router-view></router-view>
    </section>
    <the-footer></the-footer>
  </div>
</template>

<script>
import TheHeader from './components/layouts/TheHeader'
import TheFooter from './components/layouts/TheFooter'

export default {
  name: 'app',
  components: {
    TheHeader,
    TheFooter
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue